import { Controller, useForm, useFormContext, useWatch } from 'react-hook-form'
import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useMenuContext } from '../../contexts/MenuContext'
import { useEffect, useState } from 'react'
import { useAuthContext } from '../../contexts/AuthContext'
import { useRecoilValue } from 'recoil'
import selectedRestaurantSubMenusState from '../../selectors/selectedRestaurantSubmenus'
import { selectedRestaurantState } from '../../atoms/SelectedRestaurantAtom'
import { restaurantListState } from '../../atoms/RestaurantListAtom'

type PrinterFormProps = {}

function CameraForm({}: PrinterFormProps) {
  const { t } = useTranslation()
  // @ts-ignore
  const { isAdmin } = useAuthContext()
  const subMenus = useRecoilValue(selectedRestaurantSubMenusState)
  const selectedRestaurant = useRecoilValue(selectedRestaurantState)
  const restaurantList = useRecoilValue(restaurantListState)

  const {
    register,
    formState: { errors },
    control,
  } = useFormContext()

  const watchedValues = useWatch({
    control,
  })

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h5">Camera name*</Typography>
        <Typography variant="subtitle2" mb={1}>
          Ready orders camera, delivered orders camera, etc.
        </Typography>
        <TextField
          placeholder="Name"
          fullWidth
          inputProps={{ className: 'browser-default' }}
          size="small"
          {...register('name')}
          error={Boolean(errors.name)}
          helperText={errors.name?.message as string}
        />
      </Box>
      <Box>
        <Typography variant="h5" mb={1}>
          Serial Number*
        </Typography>
        {/* <Typography variant="subtitle2" mb={1}>

        </Typography> */}
        <TextField
          placeholder="Serial Number"
          fullWidth
          inputProps={{ className: 'browser-default' }}
          size="small"
          {...register('serialNumber')}
          error={Boolean(errors.serialNumber)}
          helperText={errors.serialNumber?.message as string}
        />
      </Box>

      <Stack spacing={1}>
        {/* <Typography variant="h5">Preferences</Typography>
        <Stack spacing={1}>
          <Controller
            name="shouldAutoPrintOrders"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox checked={Boolean(field.value)} onChange={field.onChange} />}
                label={
                  <span>
                    <b>Auto print orders </b>
                  </span>
                }
              />
            )}
          />
        </Stack> */}
      </Stack>
      {isAdmin && (
        <Stack spacing={1}>
          <Typography variant="h5" color="mynt.main">
            ADMIN SETTINGS
          </Typography>
          <Stack spacing={1}>
            <Box>
              <Typography variant="h5" mb={1}>
                Attached Restaurant
              </Typography>
              <Controller
                name="restaurantId"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Select size="small" fullWidth value={value} onChange={onChange} error={Boolean(errors.restaurantId)}>
                    {restaurantList?.map((restaurant: any) => (
                      <MenuItem key={restaurant?.id} value={restaurant?.id}>
                        {restaurant?.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <FormHelperText>{errors.restaurantId?.message?.toString?.()}</FormHelperText>
            </Box>
          </Stack>
        </Stack>
      )}
    </Stack>
  )
}

export default CameraForm
